import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';

@Feature()
export class OcrFeature extends BaseMobileContextMenuFeature {
    public id = config.name;

    /**
     * 打开ocr组件
     */
    public showOcr() {
        const model = this.getSelectionService().selectedElements.getCurrentModel();
        this.getAppServices().editableServiceLayer?.ocrService.promise().then((ocrService) => {
            ocrService.showOcrRightBar(model);
        });
    }
}
